import { XDayOfWeek } from '@/types/generated/graphql'
import formatEnum from './formatEnum'

type Formatter = (value: XDayOfWeek | string) => string

const formatDayOfWeek: Formatter = (value) => {
  switch (value) {
    case '0':
      return formatEnum(XDayOfWeek.Sunday, 'xDayOfWeek')
    case '1':
      return formatEnum(XDayOfWeek.Monday, 'xDayOfWeek')
    case '2':
      return formatEnum(XDayOfWeek.Tuesday, 'xDayOfWeek')
    case '3':
      return formatEnum(XDayOfWeek.Wednesday, 'xDayOfWeek')
    case '4':
      return formatEnum(XDayOfWeek.Thursday, 'xDayOfWeek')
    case '5':
      return formatEnum(XDayOfWeek.Friday, 'xDayOfWeek')
    case '6':
      return formatEnum(XDayOfWeek.Saturday, 'xDayOfWeek')
    default:
      return formatEnum(value, 'xDayOfWeek')
  }
}

export default formatDayOfWeek
